var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"collapse-field",class:{ shown: _vm.shown }},[_c('button',{staticClass:"collapse-field__caption",attrs:{"title":"Переключить видимость поля","type":"button"},on:{"click":_vm.toggle}},[_vm._v(_vm._s(_vm.caption))]),_c('div',{staticClass:"collapse-field__content"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }